// UI strings for the public site. Data-level content (products, service
// lists etc.) carries its own *Et fields and is resolved via pick().

export const translations = {
  en: {
    nav: {
      home: 'Home',
      products: 'Products',
      about: 'About',
      services: 'Services',
      quality: 'Quality',
      downloads: 'Downloads',
      contact: 'Contact',
      configurator: 'Door Configurator'
    },
    hero: {
      tagline: 'Nordic Design. Refined by Demand.',
      h1: 'Premium Wooden Exterior Doors',
      desc: 'Manufactured in Estonia for Nordic conditions — for house manufacturers, dealers, construction projects and private homes.',
      products: 'Explore Doors',
      quote: 'Request a Quote'
    },
    materials: {
      titlePre: 'Premium',
      titleHl: 'Materials',
      desc: 'We use only the finest materials in our door manufacturing process, ensuring durability, insulation, and longevity.',
      qualityTitle: 'Quality Construction',
      features: [
        {
          title: 'Multi-Layer Insulation',
          description: 'Advanced insulation core for superior thermal efficiency'
        },
        {
          title: 'Premium Wood Frame',
          description: 'FSC-certified timber options for strength and sustainability'
        },
        {
          title: 'Weather Protection',
          description: 'Multiple sealing layers protecting against all weather conditions'
        },
        {
          title: 'Quality Hardware',
          description: 'Precision-engineered hinges and locking mechanisms'
        }
      ]
    },
    about: {
      titlePre: 'About',
      titleHl: 'Hestia Doors',
      desc: 'The Hestia Doors team consists of people who have been involved in door manufacturing for decades, our common knowledge and know-how has now been applied for the success of our company.',
      features: [
        {
          title: 'Decades of Experience',
          description: 'Our team brings decades of door manufacturing experience to every project.'
        },
        {
          title: 'Expert Team',
          description: 'Skilled professionals with combined knowledge driving our company success.'
        },
        {
          title: 'Quality Assurance',
          description: 'Every door meets our rigorous standards for durability and performance.'
        },
        {
          title: 'Trusted Brand',
          description: 'Recognized reputation for excellence in exterior door manufacturing.'
        }
      ],
      whyTitle: 'Why Choose Hestia Doors?',
      bullets: [
        'Premium quality exterior doors built to last',
        'Decades of combined industry experience',
        'Custom solutions for every project',
        'Trusted by customers across Estonia'
      ],
      imageAlt: 'Modern Building Exterior'
    },
    contact: {
      titlePre: 'Get In',
      titleHl: 'Touch',
      desc: "Ready to discuss your exterior door needs? Contact our team today for a consultation.",
      infoTitle: 'Contact Information',
      address: 'Address',
      email: 'Email',
      hours: 'Business Hours',
      hoursWeekday: 'Monday - Friday: 8:00 AM - 6:00 PM',
      hoursSaturday: 'Saturday: 9:00 AM - 4:00 PM',
      hoursSunday: 'Sunday: Closed',
      whyTitle: 'Why Contact Us?',
      whyBullets: [
        'Free consultation and quote',
        'Expert advice on door selection',
        'Custom solutions available',
        'Professional installation service'
      ],
      formTitle: 'Send us a Message',
      firstName: 'First Name',
      firstNamePh: 'Your first name',
      lastName: 'Last Name',
      lastNamePh: 'Your last name',
      emailLabel: 'Email',
      emailPh: 'your.email@example.com',
      phone: 'Phone Number',
      phonePh: '+372 XXXX XXXX',
      company: 'Company',
      companyPh: 'Your company (optional)',
      country: 'Country',
      countryPh: 'e.g. Estonia',
      projectType: 'Project type',
      projectTypePh: 'e.g. private house, dealer order, development',
      quantity: 'Estimated quantity',
      quantityPh: 'e.g. 12 doors',
      subject: 'Subject',
      subjectPh: 'Door inquiry',
      message: 'Message',
      messagePh: 'Tell us about your door requirements...',
      send: 'Send Message',
      sent: 'Your email client should open with a ready message. If not, write us at info@hestiadoors.com',
      mailSubject: 'Door inquiry',
      mailBodyName: 'Name',
      mailBodyEmail: 'Email',
      mailBodyPhone: 'Phone',
      mailBodyCompany: 'Company',
      mailBodyCountry: 'Country',
      mailBodyProject: 'Project type',
      mailBodyQty: 'Quantity'
    },
    footer: {
      desc: 'Premium quality exterior doors with decades of experience and FSC-certified materials available.',
      quickLinks: 'Quick Links',
      servicesTitle: 'Our Services',
      services: [
        'Custom Manufacturing',
        'Professional Installation',
        'Maintenance & Repair',
        'Design Consultation'
      ],
      contactTitle: 'Contact',
      rights: 'All rights reserved.'
    },
    products: {
      titlePre: 'Our',
      titleHl: 'Products',
      desc: 'Explore our range of premium exterior doors, designed for durability, energy efficiency, and superior performance.',
      models: 'Models',
      model: 'Model',
      viewDetails: 'View details',
      customTitle: 'Need a Custom Solution?',
      customDesc: 'Contact us for custom door specifications, bulk orders, or technical consultation.',
      quote: 'Get Quote'
    },
    productModal: {
      keyFeatures: 'Key Features',
      technicalDetails: 'Technical Details',
      modelCode: 'Model code:',
      requestQuote: 'Request Quote',
      downloadSpecs: 'Download Specs'
    },
    productPage: {
      keyFeatures: 'Key Features',
      specs: 'Technical Specifications',
      modelCode: 'Model code',
      fromPrice: 'From',
      requestQuote: 'Request a Quote',
      backToProducts: 'All products',
      related: 'Related Products',
      configurations: 'Available configurations',
      configurationsIntro: 'Choose the base product first. Double doors and doors with one or two sidelights are available to order; final dimensions, glazing and technical details are confirmed per project.',
      availableToOrder: 'Available to order',
      configuration: 'Configuration',
      configureOrder: 'Configure & order',
      configureOrderHint: 'Choose size, sidelights and options in the configurator and see the price instantly.',
      addedToCart: 'Added to cart',
      viewCart: 'View cart',
      opening: 'Opening direction',
      notFound: 'Product not found',
      notFoundDesc: 'The product you are looking for does not exist.',
      breadcrumbHome: 'Home',
      breadcrumbProducts: 'Products'
    },
    cart: {
      title: 'Your Order',
      metaDesc: 'Review your selected doors and send an order request. We confirm availability and issue an invoice.',
      intro: 'Add doors to your order, choose quantities and send us the request. We confirm availability, dimensions and delivery, then issue an invoice — no online payment required.',
      empty: 'Your order list is empty. Browse the product range and add doors to your order.',
      browseProducts: 'Browse Products',
      qty: 'Qty',
      increase: 'Increase quantity',
      decrease: 'Decrease quantity',
      remove: 'Remove',
      totalItems: 'Total items',
      orderTitle: 'Order Request — Payment by Invoice',
      orderDesc: 'Send us your order request. We will confirm availability, final dimensions and delivery terms, and then issue an invoice to the details below.',
      fieldName: 'Name',
      fieldAddress: 'Delivery address',
      fieldMessage: 'Notes (dimensions, glazing, colours, project details)',
      submitOrder: 'Send Order Request',
      invoiceNote: 'Submitting opens your email client with a prefilled order message to info@hestiadoors.com.',
      sentTitle: 'Order request sent',
      sentDesc: 'Thank you — we will confirm the details and send you an invoice. If your email client did not open, write to info@hestiadoors.com.',
      clearCart: 'Clear cart',
      mailSubject: 'Door order request',
      mailBodyItems: 'Requested items',
      mailBodyAddress: 'Delivery address',
      configuredDoor: 'configured door',
      perUnit: 'pc',
      estimated: 'Estimated price',
      priceReviewNote: 'final price will be confirmed after technical review.',
      priceUnconfirmed: 'Price requires confirmation.'
    },
    configurator: {
      feedback: {
        button: 'Feedback',
        title: 'Tell us what you think',
        intro: 'How was the configurator? Anything confusing, missing or broken?',
        ratingLabel: 'Rating',
        messageLabel: 'Your comment',
        messagePh: 'What worked, what didn’t…',
        emailLabel: 'Email (optional, if you want a reply)',
        emailPh: 'name@example.com',
        send: 'Send feedback',
        sending: 'Sending…',
        thanks: 'Thank you! Your feedback has been saved.',
        error: 'Sending failed. Please check the email address or try again.',
        close: 'Close'
      },
      title: 'Door Configurator',
      metaDesc: 'Configure your exterior door: family, dimensions, design, colour, glass, threshold and lock. See an estimated retail price and send an order request.',
      intro: 'Choose a door family, set dimensions and options, and see your door take shape. Send the configuration with your order — we confirm the final specification and price.',
      loading: 'Loading configurator…',
      familyLabel: 'Door family',
      width: 'Width',
      height: 'Height',
      handing: 'Handing',
      opening: 'Opening direction',
      left: 'Left',
      right: 'Right',
      outward: 'Outward',
      inward: 'Inward',
      priceLabel: 'Price',
      priceCalculating: 'Calculating…',
      priceEstimate: 'Estimated price',
      priceReviewNote: 'final price will be confirmed after technical review.',
      priceUnconfirmed: 'Price requires confirmation.',
      priceDisclaimer: 'Prices are indicative and exclude delivery and installation. Final quote is confirmed by Hestia Doors.',
      qty: 'Qty',
      addToCart: 'Add configured door to cart',
      summaryPrefix: 'Configuration',
      preview: 'Door preview',
      dimensions: 'Dimensions',
      options: 'Options',
      summary: 'Summary',
      open: 'Open',
      close: 'Close',
      configuration: 'Configuration',
      customSize: 'Custom…',
      sidelightNotSupported: 'Sidelights are not available for this door family.',
      sidelightSameBoth: 'Same settings on both sides',
      leftSidelight: 'Left sidelight',
      rightSidelight: 'Right sidelight',
      sidelightWidth: 'Sidelight width',
      sidelightHeight: 'Sidelight height',
      sidelightFollowsDoor: 'Same height as the door',
      sidelightGlass: 'Sidelight glass',
      sidelightLayout: 'Layout',
      waternose: 'Waternose',
      yes: 'Yes',
      no: 'No',
      confTypes: {
        SINGLE_DOOR: 'Single door',
        DOOR_LEFT_SIDELIGHT: 'Door + left sidelight',
        DOOR_RIGHT_SIDELIGHT: 'Door + right sidelight',
        DOOR_TWO_SIDELIGHTS: 'Door + two sidelights',
        DOUBLE_DOOR: 'Double door',
        DOUBLE_DOOR_LEFT_SIDELIGHT: 'Double door + left sidelight',
        DOUBLE_DOOR_RIGHT_SIDELIGHT: 'Double door + right sidelight',
        DOUBLE_DOOR_TWO_SIDELIGHTS: 'Double door + two sidelights'
      },
      doorLeaf: 'Door leaf',
      leftLeaf: 'Left leaf',
      rightLeaf: 'Right leaf',
      leafWidths: 'Leaf widths',
      leafWindows: { label: 'Leaf window layout', none: 'Solid leaf', three: 'Three stacked windows', glass: '8 mm clear glass' },
      totalWidth: 'Total',
      sectionWidths: 'Section widths',
      doorType: 'Door',
      slSides: { none: 'None', left: 'Left', right: 'Right', both: 'Both' },
      sidelightLayouts: {
        FULL_GLASS: 'Full glass',
        ONE_HORIZONTAL_DIVIDER: '1 horizontal divider',
        TWO_HORIZONTAL_DIVIDERS: '2 horizontal dividers',
        CUSTOM: 'Custom layout'
      },
      comingSoon: 'coming soon',
      colourCode: {
        labelNCS: 'NCS code',
        labelRAL: 'RAL code',
        placeholderNCS: 'NCS code, e.g. S 2010-Y30R',
        placeholderRAL: 'RAL code, e.g. 7016',
        optional: 'Optional — leave empty and we will confirm the colour with you.',
        indicative: 'screen tone is indicative',
        notFoundNCS: 'NCS code not recognised — use the format S 2010-Y30R.',
        notFoundRAL: 'RAL code not recognised — enter a 4-digit RAL Classic code, e.g. 7016.',
        tbc: 'code to be confirmed'
      },
      groups: {
        design: 'Design',
        colour: 'Colour',
        glass: 'Glass',
        frame: 'Frame',
        threshold: 'Threshold',
        lock: 'Lock',
        hinge: 'Hinges',
        sidelight: 'Sidelights',
        extra: 'Extras'
      },
      aiViz: {
        button: 'See it on your house',
        title: 'Visualise this door on your house',
        uploadCta: 'Upload a photo of your facade',
        uploadHint: 'JPG, PNG or WebP up to 10 MB. Take the photo facing the doorway as straight-on as possible.',
        detecting: 'Finding the doorway in your photo…',
        generating: 'Creating your visualisation…',
        photoAlt: 'Uploaded facade photo',
        resultAlt: 'AI-generated door visualisation',
        disclaimer: 'AI-generated visualization. This image is illustrative and may differ from the final product in dimensions, colours, materials, lighting, hardware and installation details. Final production is based only on the approved specification and order confirmation.',
        download: 'Download image',
        newPhoto: 'Try another photo',
        close: 'Close',
        privacyNote: 'Your photo is processed securely and is not stored permanently. It is used only to create this visualisation.',
        errors: {
          invalidFile: 'Please choose a JPG, PNG or WebP image.',
          tooLarge: 'The image is too large — please use a photo under 10 MB.',
          rateLimit: 'You have reached the hourly limit for visualisations. Please try again later.',
          noDoor: 'We could not find a doorway in this photo. Try a photo taken more straight-on of the entrance.',
          captureFailed: 'Could not capture the 3D door preview. Please wait for the model to load and try again.',
          failed: 'The visualisation could not be created. Please try again.'
        }
      }
    },
    b2b: {
      titlePre: 'Exterior Doors for',
      titleHl: 'Professional Partners',
      desc: 'We manufacture exterior doors for companies that need reliable recurring production, technical documentation and project support.',
      cards: [
        {
          title: 'House Manufacturers',
          desc: 'Reliable recurring production of CE-marked exterior doors — standard sizes and project-specific solutions.'
        },
        {
          title: 'Dealers',
          desc: 'A structured product range, technical documentation and long-term partner cooperation.'
        },
        {
          title: 'Construction Projects',
          desc: 'Custom dimensions, technical support and project-based manufacturing for developers and builders.'
        }
      ],
      cta: 'Discuss Your Project'
    },
    trust: {
      items: [
        'Made in Estonia',
        'CE-marked exterior doors',
        'FSC-certified materials available',
        'Decades of door manufacturing'
      ]
    },
    categories: {
      exteriorDoors: {
        h1: 'Wooden Exterior Doors for Private Houses',
        intro: 'CE-marked outwards and inwards opening wooden exterior doors manufactured in Estonia for Nordic conditions. 60 mm door leaf, U-value down to 0,77, EPS insulation and FSC-certified materials available.',
        benefitsTitle: 'Why SMARTLINE exterior doors',
        benefits: [
          'CE-marked for private houses (EN 14351-1)',
          'U-value 0,77 for blind doors, 1,0 for glass doors',
          '60 mm insulated door leaf with EPS core',
          'Oak or aluminum thresholds, 2K clear glazing options',
          'Standard sizes 9x20/21; 9,5x20,5; 10x20/21 — custom sizes on request'
        ],
        productsTitle: 'SMARTLINE exterior door range',
        cta: 'Request a Quote'
      },
      storageDoors: {
        h1: 'Cottage & Storage Doors',
        intro: 'Durable pine-frame doors for cold stores, warm storage rooms and sheds — built for temperature differences up to 10°C or 18°C.',
        benefitsTitle: 'Built for storage buildings',
        benefits: [
          '47 mm insulated door leaf with EPS core',
          'Meranti plywood or pine paneling surfaces',
          'Pine 1-step frame 42 x 92 mm',
          'Standard sizes 9x19/20; 9,5x20,5; 9/10 x 20/21M'
        ],
        productsTitle: 'Storage door range',
        cta: 'Request a Quote'
      },
      outwardDoors: {
        h1: 'Outward-Opening Exterior Doors',
        intro: 'SMARTLINE wooden exterior doors that open outwards — the Scandinavian-standard configuration for private houses. An outward-opening leaf keeps the hallway clear, performs well against wind load and suits compact entrances. CE-marked, with a 60 mm insulated leaf and U-value down to 0,77.',
        benefitsTitle: 'Why outward-opening doors',
        benefits: [
          'CE-marked for private houses (EN 14351-1)',
          'Outward-opening leaf frees interior entrance space',
          'U-value 0,77 for blind doors, 1,0 for glass doors',
          'Single, double-door and sidelight configurations available to order',
          'Oak or aluminum thresholds, 2K clear glazing options'
        ],
        productsTitle: 'Outward-opening models',
        cta: 'Request a Quote'
      },
      inwardDoors: {
        h1: 'Inward-Opening Exterior Doors',
        intro: 'The Smartline Inward exterior door opens into the hallway — the right choice where an outward swing is impractical or an inward-opening leaf is specified. It shares the SMARTLINE construction: a 60 mm insulated leaf, U-value 0,77 for blind doors, a 2-step pine frame and an aluminum threshold.',
        benefitsTitle: 'Why an inward-opening door',
        benefits: [
          'Opens inwards — suits entrances where an outward swing is impractical',
          'U-value 0,77 for blind doors, 1,0 for glass doors',
          '60 mm door leaf with EPS insulation',
          'Pine 2-step frame 56 x 115 mm, aluminum threshold'
        ],
        productsTitle: 'Inward-opening model',
        cta: 'Request a Quote'
      },
      customDoors: {
        h1: 'Custom Exterior Doors',
        intro: 'Beyond the standard size grid, Hestia Doors manufactures exterior doors to project-specific dimensions and configurations. Glazing, thresholds, lock cases and finishes can be matched to the build — across the SMARTLINE exterior door range and our cottage, Meranti and storage door series.',
        benefitsTitle: 'Custom manufacturing options',
        benefits: [
          'Non-standard dimensions manufactured to order',
          'Glazing, threshold and lock options per project',
          'Standard sizes 9x20/21; 9,5x20,5; 10x20/21 — other sizes on request',
          'Suitable for house manufacturers, dealers and construction projects'
        ],
        productsTitle: 'Base models for custom orders',
        cta: 'Discuss Your Project'
      },
      prefabDoors: {
        h1: 'Exterior Doors for Prefabricated Houses',
        intro: 'Hestia Doors supplies CE-marked wooden exterior doors to house manufacturers and prefabricated-house producers. Consistent standard sizes, documented specifications and project-based manufacturing make the SMARTLINE range a practical fit for production-line assembly.',
        benefitsTitle: 'For prefab and modular producers',
        benefits: [
          'Standard sizes aligned with common wall openings',
          'Documented specifications: U-values, leaf construction, locks, thresholds',
          'Recurring production runs for factory installation',
          'Custom dimensions and hardware configurations on request'
        ],
        productsTitle: 'Doors suited to prefab production',
        cta: 'Discuss Your Project'
      }
    },
    common: {
      quote: 'Get Quote'
    },
    services: {
      titlePre: 'Our',
      titleHl: 'Services',
      desc: 'From initial consultation to final installation, we provide comprehensive services to ensure your door project exceeds expectations.',
      ctaTitle: 'Ready to Get Started?',
      ctaDesc: 'Contact us today to discuss your door project and receive a personalized quote.',
      viewProducts: 'View Products'
    },
    quality: {
      titlePre: 'Quality',
      titleHl: 'Assurance',
      desc: 'Our commitment to excellence ensures every door meets the highest standards of quality, durability, and performance.',
      certTitlePre: 'Certifications &',
      certTitleHl: 'Standards',
      guarTitle: 'Quality Guarantee',
      guarDesc: 'We stand behind our products with comprehensive warranties and ongoing support. Every door comes with our quality guarantee and professional service commitment.',
      learnMore: 'Learn More'
    },
    downloads: {
      titleHl: 'Downloads',
      titleRest: '& Resources',
      desc: 'Access our comprehensive library of product catalogs, technical documentation, certificates, and installation guides.',
      request: 'Request',
      docRequestSubject: 'Document request',
      docRequestBody: 'Hello,\n\nI would like to receive the document',
      docRequestThanks: 'Thank you.',
      ctaTitle: 'Need Additional Resources?',
      ctaDesc: "Can't find what you're looking for? Contact our technical support team for additional documentation, custom specifications, or technical assistance.",
      contactSupport: 'Contact Support'
    },
    notFound: {
      title: 'Page Not Found',
      text: 'Sorry, the page you are looking for does not exist or has been moved.',
      home: 'Back to Home'
    },
    projects: {
      title: 'Projects & References',
      intro: 'Completed installations and partner projects using Hestia doors.',
      empty: 'Reference projects will be published here soon. Contact us to request references for your market.',
      readMore: 'View project',
      backTo: 'All projects',
      productsUsed: 'Products used',
      requirements: 'Project requirements',
      ctaTitle: 'Planning a similar project?',
      cta: 'Request a Quote'
    },
    knowledge: {
      title: 'Knowledge',
      intro: 'Practical guidance on exterior doors: construction, U-values, opening directions and specification.',
      readArticle: 'Read article',
      backTo: 'All articles',
      relatedProducts: 'Related products',
      relatedArticles: 'Related articles',
      updated: 'Updated',
      ctaTitle: 'Need help specifying a door?',
      cta: 'Request a Quote'
    },
    seo: {
      index: {
        title: 'Premium Wooden Exterior Doors | Hestia Doors Estonia',
        description: 'Premium wooden exterior doors manufactured in Estonia for Nordic conditions. CE-marked, FSC-certified materials available, for house manufacturers, dealers and private homes.',
        keywords: 'exterior doors, wooden exterior doors, door manufacturer, Estonia, välisuksed, puituksed, uksetootja, CE-marked doors, custom doors'
      },
      exteriorDoors: {
        title: 'Wooden Exterior Doors for Houses — SMARTLINE | Hestia Doors',
        description: 'CE-marked wooden exterior doors for private houses: SMARTLINE outwards/inwards opening, U-value 0.77, 60 mm insulated leaf, FSC-certified materials available. Made in Estonia.',
        keywords: 'wooden exterior doors, exterior doors for houses, SMARTLINE doors, CE-marked doors, outwards opening doors, puituksed, välisuksed'
      },
      storageDoors: {
        title: 'Cottage & Storage Doors — Meranti & Pine | Hestia Doors',
        description: 'Doors for cold stores, warm storage rooms and sheds. 47 mm insulated leaf, Meranti plywood surfaces, pine frames. Manufactured in Estonia.',
        keywords: 'cottage doors, storage doors, shed doors, Meranti doors, suvemaja uksed, laouksed'
      },
      products: {
        title: 'Exterior Doors Products - SMARTLINE, Cottage & Meranti | Hestia Doors',
        description: 'Browse our premium exterior door range: Smartline, Smartline Inward, Cottage, Meranti and 18Deg doors. CE-marked quality.',
        keywords: 'exterior doors, SMARTLINE doors, cottage doors, Meranti doors, wooden exterior doors, välisuksed, puituksed'
      },
      about: {
        title: 'About Hestia Doors - Exterior Door Manufacturer Estonia',
        description: 'Learn about Hestia Doors: decades of experience in manufacturing premium exterior doors in Kohtla-Järve, Estonia. FSC-certified materials available, expert team.',
        keywords: 'Hestia Doors, door manufacturer Estonia, about us, exterior door company, uksetootja'
      },
      services: {
        title: 'Our Services - Custom Doors, Installation & Design | Hestia Doors',
        description: 'Custom door manufacturing, professional installation, maintenance and design consultation for exterior doors. Hestia Doors, Kohtla-Järve, Estonia.',
        keywords: 'door services, custom doors, door installation, door design, maintenance, Estonia'
      },
      quality: {
        title: 'Quality & Certifications — CE-marked Doors | Hestia Doors',
        description: 'Hestia Doors quality standards: CE certification (EN 14351-1), certified materials, rigorous testing for durability and thermal performance.',
        keywords: 'CE-marked doors, EN 14351-1, certified materials, door quality, exterior door standards'
      },
      downloads: {
        title: 'Downloads - Catalogs, Manuals & Drawings | Hestia Doors',
        description: 'Download Hestia Doors product catalogs, installation manuals, technical drawings and certificates for our exterior door range.',
        keywords: 'door catalog download, installation manual, technical drawings, door specifications'
      },
      contact: {
        title: 'Contact Us - Hestia Doors | Kohtla-Järve, Estonia',
        description: 'Contact Hestia Doors for exterior door inquiries, quotes and consultation. Päikese 1, Kohtla-Järve, Estonia. info@hestiadoors.com',
        keywords: 'contact Hestia Doors, door quote, exterior door inquiry, Kohtla-Järve'
      },
      outwardDoors: {
        title: 'Outward-Opening Exterior Doors — SMARTLINE | Hestia Doors',
        description: 'CE-marked outward-opening wooden exterior doors for private houses. U-value 0.77, 60 mm insulated leaf, oak or aluminum thresholds. Made in Estonia.',
        keywords: 'outward opening exterior doors, outswing front door, Scandinavian exterior doors, SMARTLINE doors'
      },
      inwardDoors: {
        title: 'Inward-Opening Exterior Doors — Smartline Inward | Hestia Doors',
        description: 'Smartline Inward: a CE-marked inward-opening wooden exterior door with U-value 0.77, 60 mm insulated leaf and aluminum threshold. Made in Estonia.',
        keywords: 'inward opening exterior doors, inswing front door, wooden entrance door'
      },
      customDoors: {
        title: 'Custom Exterior Doors — Made to Measure | Hestia Doors',
        description: 'Custom wooden exterior doors manufactured in Estonia: non-standard dimensions, glazing, threshold and lock options for houses, dealers and projects.',
        keywords: 'custom exterior doors, made to measure doors, bespoke wooden doors, custom front doors'
      },
      prefabDoors: {
        title: 'Exterior Doors for Prefabricated Houses | Hestia Doors',
        description: 'CE-marked wooden exterior doors for prefab and modular house producers. Standard sizes, documented specs, recurring production runs. Made in Estonia.',
        keywords: 'exterior doors for prefab houses, doors for modular homes, house manufacturer door supplier, prefab door solutions'
      },
      projects: {
        title: 'Projects & References | Hestia Doors',
        description: 'Completed projects and references using Hestia Doors exterior and storage doors across Nordic markets.',
        keywords: 'door projects, exterior door references, Hestia Doors projects'
      },
      knowledge: {
        title: 'Exterior Door Guides & Knowledge | Hestia Doors',
        description: 'Practical guides on exterior doors: opening directions, U-values, construction and specification for Nordic houses.',
        keywords: 'exterior door guide, door U-value, inward vs outward opening doors'
      },
      notFound: {
        title: 'Page Not Found | Hestia Doors',
        description: 'The page you are looking for does not exist. Visit our homepage to explore premium exterior doors.',
        keywords: ''
      },
      configurator: {
        title: 'Door Configurator — Design & Price Your Door | Hestia Doors',
        description: 'Configure your wooden exterior door: family, dimensions, design, colour, glass, threshold and lock. Estimated retail price and order request.',
        keywords: 'door configurator, custom exterior door, door price calculator, design your door'
      }
    }
  },
  et: {
    nav: {
      home: 'Avaleht',
      products: 'Tooted',
      about: 'Meist',
      services: 'Teenused',
      quality: 'Kvaliteet',
      downloads: 'Allalaadimised',
      contact: 'Kontakt',
      configurator: 'Ukse konfiguraator'
    },
    hero: {
      tagline: 'Nordic Design. Refined by Demand.',
      h1: 'Kvaliteetsed puidust välisuksed',
      desc: 'Valmistatud Eestis Põhjala tingimustesse – majatootjatele, edasimüüjatele, ehitusprojektidele ja eramutele.',
      products: 'Tutvu ustega',
      quote: 'Küsi pakkumist'
    },
    materials: {
      titlePre: 'Kvaliteetsed',
      titleHl: 'materjalid',
      desc: 'Kasutame uste valmistamisel ainult parimaid materjale, tagades vastupidavuse, soojapidavuse ja pika eluea.',
      qualityTitle: 'Kvaliteetne ehitus',
      features: [
        {
          title: 'Mitmekihiline isolatsioon',
          description: 'Täiustatud isolatsioonitäidis ülima soojapidavuse tagamiseks'
        },
        {
          title: 'Kvaliteetne puitraam',
          description: 'FSC-sertifitseeritud puiduvalik tugevuse ja jätkusuutlikkuse tagamiseks'
        },
        {
          title: 'Ilmastikukaitse',
          description: 'Mitu tihenduskihti kaitseks kõigi ilmastikutingimuste eest'
        },
        {
          title: 'Kvaliteetsed liigendid ja lukud',
          description: 'Täppistöödeldud hinged ja lukustusmehhanismid'
        }
      ]
    },
    about: {
      titlePre: 'Meist –',
      titleHl: 'Hestia Doors',
      desc: 'Hestia Doorsi meeskonda kuuluvad inimesed, kes on uste tootmisega tegelenud aastakümneid – ühised teadmised ja kogemused on nüüd rakendatud meie ettevõtte eduks.',
      features: [
        {
          title: 'Aastakümnete kogemus',
          description: 'Meie meeskond toob igasse projekti aastakümnete uste tootmise kogemuse.'
        },
        {
          title: 'Ekspertidest meeskond',
          description: 'Oskusstad spetsialistid, kelle ühised teadmised juhivad meie ettevõtte edu.'
        },
        {
          title: 'Kvaliteedigarantii',
          description: 'Iga uks vastab meie rangele vastupidavuse ja toimivuse standardile.'
        },
        {
          title: 'Usaldusväärne bränd',
          description: 'Tunnustatud maine välisuuste tootmise tipptasemel.'
        }
      ],
      whyTitle: 'Miks valida Hestia Doors?',
      bullets: [
        'Kvaliteetsed välisuksed, mis on ehitatud kestma',
        'Aastakümnete ühine kogemus valdkonnas',
        'Erilahendused igale projektile',
        'Klientide usaldus üle Eesti'
      ],
      imageAlt: 'Kaasaegne hoone väljanägu'
    },
    contact: {
      titlePre: 'Võta',
      titleHl: 'ühendust',
      desc: 'Oled valmis arutama oma välisukse vajadusi? Võta meiega täna ühendust konsultatsiooniks.',
      infoTitle: 'Kontaktandmed',
      address: 'Aadress',
      email: 'E-post',
      hours: 'Lahtiolekuajad',
      hoursWeekday: 'E–R: 8:00–18:00',
      hoursSaturday: 'L: 9:00–16:00',
      hoursSunday: 'P: suletud',
      whyTitle: 'Miks meiega ühendust võtta?',
      whyBullets: [
        'Tasuta konsultatsioon ja hinnapakkumine',
        'Asjatundlik nõustamine ukse valikul',
        'Saadaval erilahendused',
        'Professionaalne paigaldusteenus'
      ],
      formTitle: 'Saada meile sõnum',
      firstName: 'Eesnimi',
      firstNamePh: 'Sinu eesnimi',
      lastName: 'Perekonnanimi',
      lastNamePh: 'Sinu perekonnanimi',
      emailLabel: 'E-post',
      emailPh: 'sinu.epost@naide.ee',
      phone: 'Telefoninumber',
      phonePh: '+372 XXXX XXXX',
      company: 'Ettevõte',
      companyPh: 'Sinu ettevõte (valikuline)',
      country: 'Riik',
      countryPh: 'nt Eesti',
      projectType: 'Projekti tüüp',
      projectTypePh: 'nt eramu, edasimüügi tellimus, arendus',
      quantity: 'Hinnanguline kogus',
      quantityPh: 'nt 12 ust',
      subject: 'Teema',
      subjectPh: 'Ukse päring',
      message: 'Sõnum',
      messagePh: 'Räägi meile oma ukse vajadustest...',
      send: 'Saada sõnum',
      sent: 'Sinu e-posti klient peaks avanema valmis sõnumiga. Kui mitte, kirjuta meile info@hestiadoors.com',
      mailSubject: 'Ukse päring',
      mailBodyName: 'Nimi',
      mailBodyEmail: 'E-post',
      mailBodyPhone: 'Telefon',
      mailBodyCompany: 'Ettevõte',
      mailBodyCountry: 'Riik',
      mailBodyProject: 'Projekti tüüp',
      mailBodyQty: 'Kogus'
    },
    footer: {
      desc: 'Kvaliteetsed välisuksed aastakümnete kogemuse ja FSC-sertifitseeritud materjalidega saadaval.',
      quickLinks: 'Kiirlingid',
      servicesTitle: 'Meie teenused',
      services: [
        'Erinditootmine',
        'Professionaalne paigaldus',
        'Hooldus ja remont',
        'Disaini nõustamine'
      ],
      contactTitle: 'Kontakt',
      rights: 'Kõik õigused kaitstud.'
    },
    products: {
      titlePre: 'Meie',
      titleHl: 'tooted',
      desc: 'Tutvu meie kvaliteetsete välisuuste valikuga – loodud vastupidavuse, energiatõhususe ja suurepärase toimivuse jaoks.',
      models: 'mudelit',
      model: 'mudel',
      viewDetails: 'Vaata lähemalt',
      customTitle: 'Vajad erilahendust?',
      customDesc: 'Võta meiega ühendust eritellimuste, hulgimüügi või tehnilise nõustamise osas.',
      quote: 'Küsi pakkumist'
    },
    productModal: {
      keyFeatures: 'Põhiomadused',
      technicalDetails: 'Tehnilised andmed',
      modelCode: 'Mudelikood:',
      requestQuote: 'Küsi pakkumist',
      downloadSpecs: 'Laadi spetsifikatsioonid'
    },
    productPage: {
      keyFeatures: 'Põhiomadused',
      specs: 'Tehnilised andmed',
      modelCode: 'Mudelikood',
      fromPrice: 'Alates',
      requestQuote: 'Küsi pakkumist',
      backToProducts: 'Kõik tooted',
      related: 'Seotud tooted',
      configurations: 'Saadaval konfiguratsioonid',
      configurationsIntro: 'Vali esmalt põhitoode. Topeltuksed ning ühe või kahe küljevalgustiga uksed on saadaval tellimisel; lõplikud mõõdud, klaasilahendus ja tehnilised detailid kinnitatakse projektipõhiselt.',
      availableToOrder: 'Saadaval tellimisel',
      configuration: 'Konfiguratsioon',
      configureOrder: 'Konfigureeri ja telli',
      configureOrderHint: 'Vali konfiguraatoris mõõdud, küljevalgustid ja valikud ning näed hinda kohe.',
      addedToCart: 'Lisatud ostukorvi',
      viewCart: 'Vaata ostukorvi',
      opening: 'Avamissuund',
      notFound: 'Toodet ei leitud',
      notFoundDesc: 'Otsitavat toodet ei eksisteeri.',
      breadcrumbHome: 'Avaleht',
      breadcrumbProducts: 'Tooted'
    },
    cart: {
      title: 'Sinu tellimus',
      metaDesc: 'Vaata valitud uksed üle ja saada tellimuse päring. Kinnitame saadavuse ja väljastame arve.',
      intro: 'Lisa uksed tellimusse, vali kogused ja saada päring. Kinnitame saadavuse, mõõdud ja tarne ning väljastame seejärel arve — veebimakset ei nõuta.',
      empty: 'Sinu tellimus on tühi. Sirvi tootevalikut ja lisa uksed tellimusse.',
      browseProducts: 'Sirvi tooteid',
      qty: 'Kogus',
      increase: 'Suurenda kogust',
      decrease: 'Vähenda kogust',
      remove: 'Eemalda',
      totalItems: 'Kokku',
      orderTitle: 'Tellimuse päring — tasumine arve alusel',
      orderDesc: 'Saada meile tellimuse päring. Kinnitame saadavuse, lõplikud mõõdud ja tarnetingimused ning väljastame arve allpool toodud andmetele.',
      fieldName: 'Nimi',
      fieldAddress: 'Tarneaadress',
      fieldMessage: 'Lisainfo (mõõdud, klaasid, värvid, projekti detailid)',
      submitOrder: 'Saada tellimus',
      invoiceNote: 'Saatmine avab sinu meiliprogrammi eeltäidetud tellimuskirjaga aadressile info@hestiadoors.com.',
      sentTitle: 'Tellimus saadetud',
      sentDesc: 'Aitäh — kinnitame detailid ja saadame sulle arve. Kui meiliprogramm ei avanenud, kirjuta info@hestiadoors.com.',
      clearCart: 'Tühjenda ostukorv',
      mailSubject: 'Uste tellimus',
      mailBodyItems: 'Soovitud tooted',
      mailBodyAddress: 'Tarneaadress',
      configuredDoor: 'konfigureeritud uks',
      perUnit: 'tk',
      estimated: 'Hinnanguline hind',
      priceReviewNote: 'lõplik hind kinnitatakse pärast tehnilist ülevaatust.',
      priceUnconfirmed: 'Hind vajab kinnitamist.'
    },
    configurator: {
      feedback: {
        button: 'Tagasiside',
        title: 'Anna meile tagasisidet',
        intro: 'Kuidas konfiguraator sulle tundus? Kas midagi oli segane, puudu või katki?',
        ratingLabel: 'Hinnang',
        messageLabel: 'Sinu kommentaar',
        messagePh: 'Mis töötas, mis mitte…',
        emailLabel: 'E-post (valikuline, kui soovid vastust)',
        emailPh: 'nimi@näide.ee',
        send: 'Saada tagasiside',
        sending: 'Saadan…',
        thanks: 'Aitäh! Sinu tagasiside on salvestatud.',
        error: 'Saatmine ebaõnnestus. Kontrolli e-posti aadressi või proovi uuesti.',
        close: 'Sulge'
      },
      title: 'Ukse konfiguraator',
      metaDesc: 'Konfigureeri oma välisuks: mudel, mõõdud, disain, värv, klaas, lävi ja lukk. Vaata hinnangulist jaehinda ja saada tellimuse päring.',
      intro: 'Vali uksemudel, määra mõõdud ja valikud ning näe ust kujunemas. Saada konfiguratsioon koos tellimusega — kinnitame lõpliku spetsifikatsiooni ja hinna.',
      loading: 'Laen konfiguraatorit…',
      familyLabel: 'Uksemudel',
      width: 'Laius',
      height: 'Kõrgus',
      handing: 'Poolus',
      opening: 'Avamissuund',
      left: 'Vasak',
      right: 'Parem',
      outward: 'Väljapoole',
      inward: 'Sissepoole',
      priceLabel: 'Hind',
      priceCalculating: 'Arvutan…',
      priceEstimate: 'Hinnanguline hind',
      priceReviewNote: 'lõplik hind kinnitatakse pärast tehnilist ülevaatust.',
      priceUnconfirmed: 'Hind vajab kinnitamist.',
      priceDisclaimer: 'Hinnad on näitlikud ega sisalda transporti ega paigaldust. Lõpliku pakkumise kinnitab Hestia Doors.',
      qty: 'Kogus',
      addToCart: 'Lisa konfigureeritud uks ostukorvi',
      summaryPrefix: 'Konfiguratsioon',
      preview: 'Ukse eelvaade',
      dimensions: 'Mõõtmed',
      options: 'Valikud',
      summary: 'Kokkuvõte',
      open: 'Ava',
      close: 'Sule',
      configuration: 'Konfiguratsioon',
      customSize: 'Kohandatud…',
      sidelightNotSupported: 'Küljevalgustid pole selle uksemudeli jaoks saadaval.',
      sidelightSameBoth: 'Sama seadistus mõlemal poolel',
      leftSidelight: 'Vasak küljevalgusti',
      rightSidelight: 'Parem küljevalgusti',
      sidelightWidth: 'Küljevalgusti laius',
      sidelightHeight: 'Küljevalgusti kõrgus',
      sidelightFollowsDoor: 'Uksega sama kõrgus',
      sidelightGlass: 'Küljevalgusti klaas',
      sidelightLayout: 'Jaotus',
      waternose: 'Veenina',
      yes: 'Jah',
      no: 'Ei',
      confTypes: {
        SINGLE_DOOR: 'Üks uks',
        DOOR_LEFT_SIDELIGHT: 'Uks + vasak küljevalgusti',
        DOOR_RIGHT_SIDELIGHT: 'Uks + parem küljevalgusti',
        DOOR_TWO_SIDELIGHTS: 'Uks + kaks küljevalgusti',
        DOUBLE_DOOR: 'Topeltuks',
        DOUBLE_DOOR_LEFT_SIDELIGHT: 'Topeltuks + vasak küljevalgusti',
        DOUBLE_DOOR_RIGHT_SIDELIGHT: 'Topeltuks + parem küljevalgusti',
        DOUBLE_DOOR_TWO_SIDELIGHTS: 'Topeltuks + kaks küljevalgusti'
      },
      doorLeaf: 'Ukseleht',
      leftLeaf: 'Vasak leht',
      rightLeaf: 'Parem leht',
      leafWidths: 'Lehtede laiused',
      leafWindows: { label: 'Ukselehe aknaavad', none: 'Avadeta ukseleht', three: 'Kolm ava üksteise kohal', glass: '8 mm selge klaas' },
      totalWidth: 'Kokku',
      sectionWidths: 'Sektsioonide laiused',
      doorType: 'Uks',
      slSides: { none: 'Puudub', left: 'Vasak', right: 'Parem', both: 'Mõlemad' },
      sidelightLayouts: {
        FULL_GLASS: 'Täisklaas',
        ONE_HORIZONTAL_DIVIDER: '1 horisontaalne jagaja',
        TWO_HORIZONTAL_DIVIDERS: '2 horisontaalset jagajat',
        CUSTOM: 'Erilahendus'
      },
      comingSoon: 'tulekul',
      colourCode: {
        labelNCS: 'NCS kood',
        labelRAL: 'RAL kood',
        placeholderNCS: 'NCS kood, nt S 2010-Y30R',
        placeholderRAL: 'RAL kood, nt 7016',
        optional: 'Valikuline — jäta tühjaks ja täpsustame tooni sinuga.',
        indicative: 'ekraanitoon on ligikaudne',
        notFoundNCS: 'NCS koodi ei tuvastatud — kasuta vormingut S 2010-Y30R.',
        notFoundRAL: 'RAL koodi ei tuvastatud — sisesta 4-kohaline RAL Classic kood, nt 7016.',
        tbc: 'kood täpsustamisel'
      },
      groups: {
        design: 'Disain',
        colour: 'Värv',
        glass: 'Klaas',
        frame: 'Raam',
        threshold: 'Lävi',
        lock: 'Lukk',
        hinge: 'Hinged',
        sidelight: 'Küljevalgustid',
        extra: 'Lisad'
      },
      aiViz: {
        button: 'Proovi oma majal',
        title: 'Visualiseeri uks oma majal',
        uploadCta: 'Laadi üles foto oma fassaadist',
        uploadHint: 'JPG, PNG või WebP kuni 10 MB. Pildista ukseava võimalikult otse eestvaates.',
        detecting: 'Otsin pildilt ukseava…',
        generating: 'Loon visualiseeringut…',
        photoAlt: 'Üles laaditud fassaadifoto',
        resultAlt: 'AI loodud ukse visualiseering',
        disclaimer: 'AI loodud visualiseering. Pilt on illustratiivne ning võib lõpptootest erineda mõõtude, värvitooni, materjalide, valgustuse, furnituuri ja paigaldusdetailide poolest. Tootmise aluseks on ainult kinnitatud spetsifikatsioon ja tellimuse kinnitus.',
        download: 'Laadi pilt alla',
        newPhoto: 'Proovi teise fotoga',
        close: 'Sulge',
        privacyNote: 'Sinu fotot töödeldakse turvaliselt ja seda ei salvestata püsivalt. Seda kasutatakse ainult visualiseeringu loomiseks.',
        errors: {
          invalidFile: 'Palun vali JPG, PNG või WebP pilt.',
          tooLarge: 'Pilt on liiga suur — kasuta alla 10 MB fotot.',
          rateLimit: 'Visualiseerimiste tunnilimiit on täis. Palun proovi hiljem uuesti.',
          noDoor: 'Pildilt ei õnnestunud ukseava leida. Proovi fotot, mis on tehtud sissepääsust otsemalt.',
          captureFailed: '3D ukse pildi tegemine ebaõnnestus. Oota, kuni mudel on laadinud, ja proovi uuesti.',
          failed: 'Visualiseeringu loomine ebaõnnestus. Palun proovi uuesti.'
        }
      }
    },
    b2b: {
      titlePre: 'Välisuksed',
      titleHl: 'professionaalidele',
      desc: 'Toodame välisuksi ettevõtetele, kes vajavad usaldusväärset seeriatootmist, tehnilist dokumentatsiooni ja projektituge.',
      cards: [
        {
          title: 'Majatootjad',
          desc: 'CE-märgistatud välisuuste usaldusväärne seeriatootmine – standardsuurused ja projektipõhised lahendused.'
        },
        {
          title: 'Edasimüüjad',
          desc: 'Struktureeritud tootevalik, tehniline dokumentatsioon ja pikaajaline partnerlus.'
        },
        {
          title: 'Ehitusprojektid',
          desc: 'Erimõõdud, tehniline tugi ja projektipõhine tootmine arendajatele ja ehitajatele.'
        }
      ],
      cta: 'Aruta oma projekti'
    },
    trust: {
      items: [
        'Valmistatud Eestis',
        'CE-märgistatud välisuksed',
        'FSC-sertifitseeritud materjalid saadaval',
        'Aastakümnete uksetootmise kogemus'
      ]
    },
    categories: {
      exteriorDoors: {
        h1: 'Puidust välisuksed eramutele',
        intro: 'CE-märgistatud välja- ja sissepoole avanevad puidust välisuksed, valmistatud Eestis Põhjala tingimustesse. 60 mm ukseleht, U-väärtus kuni 0,77, EPS-isolatsioon ja FSC-sertifitseeritud materjalid saadaval.',
        benefitsTitle: 'Miks SMARTLINE välisuksed',
        benefits: [
          'CE-märgistatud eramutele (EN 14351-1)',
          'U-väärtus 0,77 pimendatud ustele, 1,0 klaasustele',
          '60 mm isoleeritud ukseleht EPS-täidisega',
          'Tamme- või alumiiniumlävi, 2K klaasivalikud',
          'Standardsuurused 9x20/21; 9,5x20,5; 10x20/21 – erimõõdud tellimisel'
        ],
        productsTitle: 'SMARTLINE välisuuste valik',
        cta: 'Küsi pakkumist'
      },
      storageDoors: {
        h1: 'Suvemaja- ja laouksed',
        intro: 'Vastupidavad männiraamiga uksed külmlaadadele, soaladele ja kuuridele – loodud kuni 10°C või 18°C temperatuurierinevuse jaoks.',
        benefitsTitle: 'Loodud abihoonetele',
        benefits: [
          '47 mm isoleeritud ukseleht EPS-täidisega',
          'Meranti vineeri või männivooderdisega pinnad',
          'Männist 1-astmeline raam 42 x 92 mm',
          'Standardsuurused 9x19/20; 9,5x20,5; 9/10 x 20/21M'
        ],
        productsTitle: 'Laouste valik',
        cta: 'Küsi pakkumist'
      },
      outwardDoors: {
        h1: 'Väljapoole avanevad välisuksed',
        intro: 'Väljapoole avanevad SMARTLINE puidust välisuksed — Skandinaavias tavaline lahendus eramutele. Väljapoole avanev ukselaba jätab esiku vabaks, talub hästi tuulekoormust ja sobib kompaktsetesse sissekäikudesse. CE-märgistatud, 60 mm soojustatud laba ja U-väärtus kuni 0,77.',
        benefitsTitle: 'Miks väljapoole avanev uks',
        benefits: [
          'CE-märgistatud eramutele (EN 14351-1)',
          'Väljapoole avanev laba vabastab esiku ruumi',
          'U-väärtus 0,77 pimendatud ustele, 1,0 klaasustele',
          'Ühepoolne, topeltukse ja küljevalgustiga lahendus saadaval tellimisel',
          'Tamme- või alumiiniumlävi, 2K klaasvalikud'
        ],
        productsTitle: 'Väljapoole avanevad mudelid',
        cta: 'Küsi pakkumist'
      },
      inwardDoors: {
        h1: 'Sissepoole avanevad välisuksed',
        intro: 'Smartline Inward välisuks avaneb esiku suunas — õige valik, kui väljapoole avanemine on ebapraktiline või nõutud on sissepoole avanev laba. Sama SMARTLINE ehitus: 60 mm soojustatud laba, U-väärtus 0,77 pimendatud ustele, 2-astmeline männiraam ja alumiiniumlävi.',
        benefitsTitle: 'Miks sissepoole avanev uks',
        benefits: [
          'Avaneb sissepoole — sobib, kui väljapoole avanemine on ebamugav',
          'U-väärtus 0,77 pimendatud ustele, 1,0 klaasustele',
          '60 mm ukselaba EPS-isolatsiooniga',
          'Männist 2-astmeline raam 56 x 115 mm, alumiiniumlävi'
        ],
        productsTitle: 'Sissepoole avanev mudel',
        cta: 'Küsi pakkumist'
      },
      customDoors: {
        h1: 'Eritellimusel välisuksed',
        intro: 'Lisaks standardsuurustele valmistab Hestia Doors välisuksi projektipäraste mõõtude ja konfiguratsioonidega. Klaasid, läved, lukukorpused ja viimistlus saab sobitada ehitisega — nii SMARTLINE välisuste valikus kui ka suvemaja-, Meranti- ja laouste seerias.',
        benefitsTitle: 'Eritellimuse võimalused',
        benefits: [
          'Mittestandardsed mõõdud tellimuse alusel',
          'Mittestandardsed mõõdud tellimuse alusel',
          'Klaasi-, läve- ja lukuvõimalused projekti järgi',
          'Standardsuurused 9x20/21; 9,5x20,5; 10x20/21 — muud suurused päringu alusel',
          'Sobib majatootjatele, edasimüüjatele ja ehitusprojektidele'
        ],
        productsTitle: 'Eritellimuste alusmudelid',
        cta: 'Arutame teie projekti'
      },
      prefabDoors: {
        h1: 'Välisuksed element- ja moodulmajadele',
        intro: 'Hestia Doors varustab majatootjaid ja elementmajade tootjaid CE-märgistatud puidust välisustega. Ühtsed standardsuurused, dokumenteeritud tehnilised andmed ja projektipõhine tootmine teevad SMARTLINE seeriast praktilise valiku tehase paigalduseks.',
        benefitsTitle: 'Element- ja moodulmajade tootjatele',
        benefits: [
          'Standardsuurused kooskõlas tüüpiliste seinaavadega',
          'Dokumenteeritud andmed: U-väärtused, laba ehitus, lukud, läved',
          'Korduvad tootmispartiid tehase paigalduseks',
          'Erimõõdud ja furnituuri konfiguratsioonid tellimuse alusel'
        ],
        productsTitle: 'Elementmajadele sobivad uksed',
        cta: 'Arutame teie projekti'
      }
    },
    common: {
      quote: 'Küsi pakkumist'
    },
    services: {
      titlePre: 'Meie',
      titleHl: 'teenused',
      desc: 'Alates esmasest konsultatsioonist kuni lõpliku paigalduseni pakume terviklikke teenuseid, et su ukseprojekt ületaks ootusi.',
      ctaTitle: 'Valmis alustama?',
      ctaDesc: 'Võta meiega täna ühendust, et arutada oma ukseprojekti ja saada personaalne hinnapakkumine.',
      viewProducts: 'Vaata tooteid'
    },
    quality: {
      titlePre: 'Kvaliteedi',
      titleHl: 'tagamine',
      desc: 'Meie pühendumus tipptasemele tagab, et iga uks vastab kõrgeimatele kvaliteedi-, vastupidavus- ja toimivusstandarditele.',
      certTitlePre: 'Sertifikaadid ja',
      certTitleHl: 'standardid',
      guarTitle: 'Kvaliteedigarantii',
      guarDesc: 'Seisame oma toodete taga põhjalike garantiide ja jätkuva toega. Iga uks on kaetud meie kvaliteedigarantii ja professionaalse teenindusega.',
      learnMore: 'Loe lähemalt'
    },
    downloads: {
      titleHl: 'Allalaadimised',
      titleRest: 'ja materjalid',
      desc: 'Tutvu meie põhjaliku tootekataloogide, tehnilise dokumentatsiooni, sertifikaatide ja paigaldusjuhendite koguga.',
      request: 'Päri',
      docRequestSubject: 'Dokumendi päring',
      docRequestBody: 'Tere,\n\nSooviksin saada dokumenti',
      docRequestThanks: 'Tänan.',
      ctaTitle: 'Vajad lisamaterjale?',
      ctaDesc: 'Ei leidnud otsitut? Võta ühendust meie tehnilise toega lisadokumentatsiooni, erispetsifikatsioonide või tehnilise abi saamiseks.',
      contactSupport: 'Võta ühendust'
    },
    notFound: {
      title: 'Lehte ei leitud',
      text: 'Vabandust, otsitavat lehte ei eksisteeri või see on teisaldatud.',
      home: 'Tagasi avalehele'
    },
    projects: {
      title: 'Projektid ja referentsid',
      intro: 'Lõpetatud paigaldused ja partnerprojektid, kus kasutatakse Hestia uksi.',
      empty: 'Referentsprojektid avaldatakse siin peagi. Küsi meilt referentse oma turu kohta.',
      readMore: 'Vaata projekti',
      backTo: 'Kõik projektid',
      productsUsed: 'Kasutatud tooted',
      requirements: 'Projekti nõuded',
      ctaTitle: 'Planeerite sarnast projekti?',
      cta: 'Küsi pakkumist'
    },
    knowledge: {
      title: 'Teadmised',
      intro: 'Praktiline juhend välisuste kohta: ehitus, U-väärtused, avanemissuunad ja spetsifitseerimine.',
      readArticle: 'Loe artiklit',
      backTo: 'Kõik artiklid',
      relatedProducts: 'Seotud tooted',
      relatedArticles: 'Seotud artiklid',
      updated: 'Uuendatud',
      ctaTitle: 'Vajate abi ukse valikul?',
      cta: 'Küsi pakkumist'
    },
    seo: {
      index: {
        title: 'Kvaliteetsed puidust välisuksed | Hestia Doors Eestis',
        description: 'Kvaliteetsed puidust välisuksed, valmistatud Eestis Põhjala tingimustesse. CE-märgistatud, FSC-materjalid saadaval – majatootjatele, edasimüüjatele ja eramutele.',
        keywords: 'välisuksed, puituksed, uksetootja, eramu uksed, välisuks Eestisse, CE-märgistatud uksed, eritellimus uksed'
      },
      exteriorDoors: {
        title: 'Puidust välisuksed eramutele – SMARTLINE | Hestia Doors',
        description: 'CE-märgistatud puidust välisuksed eramutele: SMARTLINE välja- ja sissepoole avanevad, U-väärtus 0,77, 60 mm isoleeritud ukseleht, FSC-materjalid saadaval.',
        keywords: 'puidust välisuksed, välisuksed eramule, SMARTLINE uksed, CE-märgistatud uksed, väljapoole avanev uks'
      },
      storageDoors: {
        title: 'Suvemaja- ja laouksed – Meranti ja mänd | Hestia Doors',
        description: 'Uksed külmlaadadele, soaladele ja kuuridele. 47 mm isoleeritud ukseleht, Meranti vineeri pinnad, männiraamid. Valmistatud Eestis.',
        keywords: 'suvemaja uksed, laouksed, kuuriuksed, Meranti uksed, külmhoone uksed'
      },
      products: {
        title: 'Välisuksed – SMARTLINE, suvemaja ja Meranti uksed | Hestia Doors',
        description: 'Tutvu meie välisuuste valikuga: Smartline, Smartline Inward, Cottage, Meranti ja 18Deg uksed. CE-märgistatud kvaliteet.',
        keywords: 'välisuksed, SMARTLINE uksed, suvemaja uksed, Meranti uksed, puituksed, eramu välisuks'
      },
      about: {
        title: 'Meist – Hestia Doors | Välisuuste tootja Eestis',
        description: 'Tutvu Hestia Doorsiga: aastakümnete kogemusega välisuuste tootja Kohtla-Järvel. FSC-sertifitseeritud materjalid saadaval ja ekspertidest meeskond.',
        keywords: 'Hestia Doors, uksetootja Eestis, meist, välisuuste tootja'
      },
      services: {
        title: 'Teenused – eritellimus uksed, paigaldus ja disain | Hestia Doors',
        description: 'Välisuuste eritellimus tootmine, professionaalne paigaldus, hooldus ja disaini nõustamine. Hestia Doors, Kohtla-Järve.',
        keywords: 'ukseteenused, eritellimus uksed, ukse paigaldus, ukse disain, uste hooldus'
      },
      quality: {
        title: 'Kvaliteet ja sertifikaadid – CE-märgistatud uksed | Hestia Doors',
        description: 'Hestia Doorsi kvaliteedistandardid: CE-sertifikaat (EN 14351-1), sertifitseeritud materjalid ning põhjalik vastupidavuse ja soojapidavuse testimine.',
        keywords: 'CE-märgistatud uksed, EN 14351-1, sertifitseeritud materjalid, ukse kvaliteet, välisuuste standardid'
      },
      downloads: {
        title: 'Allalaadimised – kataloogid, juhendid ja joonised | Hestia Doors',
        description: 'Laadi alla Hestia Doorsi tootekataloogid, paigaldusjuhendid, tehnilised joonised ja sertifikaadid meie välisuuste kohta.',
        keywords: 'uksekataloog, paigaldusjuhend, tehnilised joonised, ukse spetsifikatsioonid'
      },
      contact: {
        title: 'Kontakt – Hestia Doors | Kohtla-Järve',
        description: 'Võta ühendust Hestia Doorsiga välisuuste päringute, hinnapakkumiste ja nõustamise osas. Päikese 1, Kohtla-Järve. info@hestiadoors.com',
        keywords: 'Hestia Doors kontakt, ukse hinnapakkumine, välisukse päring, Kohtla-Järve'
      },
      outwardDoors: {
        title: 'Väljapoole avanevad välisuksed — SMARTLINE | Hestia Doors',
        description: 'CE-märgistatud väljapoole avanevad puidust välisuksed eramutele. U-väärtus 0,77, 60 mm soojustatud laba, tamme- või alumiiniumlävi. Valmistatud Eestis.',
        keywords: 'väljapoole avanevad välisuksed, puituksed, SMARTLINE uksed'
      },
      inwardDoors: {
        title: 'Sissepoole avanevad välisuksed — Smartline Inward | Hestia Doors',
        description: 'Smartline Inward: CE-märgistatud sissepoole avanev puidust välisuks, U-väärtus 0,77, 60 mm soojustatud laba ja alumiiniumlävi. Valmistatud Eestis.',
        keywords: 'sissepoole avanevad välisuksed, puituksed, esikuuksed'
      },
      customDoors: {
        title: 'Eritellimusel välisuksed — mõõdu järgi | Hestia Doors',
        description: 'Eritellimusel puidust välisuksed Eestist: mittestandardsed mõõdud, klaasi-, läve- ja lukuvõimalused eramutele, edasimüüjatele ja projektidele.',
        keywords: 'eritellimusel välisuksed, mõõdu järgi uksed, eritellimus uksed'
      },
      prefabDoors: {
        title: 'Välisuksed elementmajadele | Hestia Doors',
        description: 'CE-märgistatud puidust välisuksed element- ja moodulmajade tootjatele. Standardsuurused, dokumenteeritud andmed, korduvad partiid. Valmistatud Eestis.',
        keywords: 'uksed elementmajadele, majatootja uksetarnija, elementmaja uksed'
      },
      projects: {
        title: 'Projektid ja referentsid | Hestia Doors',
        description: 'Lõpetatud projektid ja referentsid Hestia Doorsi välis- ja laoustega Põhjamaade turgudel.',
        keywords: 'ukseprojektid, välisuste referentsid, Hestia Doors projektid'
      },
      knowledge: {
        title: 'Välisuste juhendid ja teadmised | Hestia Doors',
        description: 'Praktilised juhendid välisuste kohta: avanemissuunad, U-väärtused, ehitus ja spetsifitseerimine Põhjala majadele.',
        keywords: 'välisuste juhend, ukse U-väärtus, sisse- või väljapoole avanev uks'
      },
      notFound: {
        title: 'Lehte ei leitud | Hestia Doors',
        description: 'Otsitavat lehte ei eksisteeri. Külasta avalehte ja tutvu kvaliteetsete välisuustega.',
        keywords: ''
      },
      configurator: {
        title: 'Ukse konfiguraator — kujunda ja hinna oma uks | Hestia Doors',
        description: 'Konfigureeri puidust välisuks: mudel, mõõdud, disain, värv, klaas, lävi ja lukk. Hinnanguline jaehind ja tellimuse päring.',
        keywords: 'ukse konfiguraator, eritellimusel välisuks, ukse hind, kujunda uks'
      }
    }
  },


  // Danish — TRANSLATION PENDING. See DANISH_TRANSLATION_REQUIRED.md.
  // Keys are intentionally omitted: t() falls back to English and /da routes
  // are gated + noindexed until 'da' is added to ACTIVE_LANGS in i18n/config.js.
  da: {}
};
